module.exports = __webpack_public_path__ + "static/media/loading.054692ec.gif";